import { useSelectedMpProductsStore } from '../stores/selectedMpProductsStore';

export const useSelectedMpProducts = () => {
  const selectedMpProducts = useSelectedMpProductsStore(
    (state) => state.selectedMpProducts
  );
  const addSelectedMpProducts = useSelectedMpProductsStore(
    (state) => state.addSelectedMpProducts
  );
  const clearSelectedMpProducts = useSelectedMpProductsStore(
    (state) => state.clearSelectedMpProducts
  );
  const isSelectedMpProductsLoaded = useSelectedMpProductsStore((state) =>
    state.isSelectedMpProductsLoaded()
  );
  const updateSelectedMpProducts = useSelectedMpProductsStore(
    (state) => state.updateSelectedMpProducts
  );
  const removeSelectedMpProduct = useSelectedMpProductsStore(
    (state) => state.removeSelectedMpProduct
  );
  const isMpProductSelected = useSelectedMpProductsStore(
    (state) => state.isMpProductSelected
  );
  const getSelectedMpProductIds = useSelectedMpProductsStore(
    (state) => state.getSelectedMpProductIds
  );

  return {
    selectedMpProducts,
    isLoaded: isSelectedMpProductsLoaded,
    addSelectedMpProducts,
    clearSelectedMpProducts,
    updateSelectedMpProducts,
    removeSelectedMpProduct,
    isMpProductSelected,
    getSelectedMpProductIds,
  };
};
